import { render, staticRenderFns } from "./total_profit.vue?vue&type=template&id=fc272ac8&scoped=true&"
import script from "./total_profit.vue?vue&type=script&lang=js&"
export * from "./total_profit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc272ac8",
  null
  
)

export default component.exports